/**
 * Iris Learns Bundle
 * Bundles Iris Learner device + Exo Works Learner
 * Optional add-ons: Extended Warranty & Exo Works Essentials
 * Adds all selected items to cart on single "Add to Cart" click
 */

class IrisLearnsBundle {
  constructor() {
    console.log('=== Iris Learns Bundle Initialized ===');
    
    this.bundleItems = {
      device: {
        variantId: 52591082897592,
        name: 'Exo Iris'
      },
      software: {
        variantId: 52846917419192,
        name: 'Exo Works Essential Software'
      }
    };

    this.addons = {
      warranty: {
        name: 'Device Protection',
        image: 'https://cdn.shopify.com/s/files/1/0778/3802/4888/files/Extended_Warranty_a4faaf5d-5d56-46de-8b28-3441207f6815.png?v=1771546472',
        enabled: false,
        selectedYear: '1year',
        variants: {
          '1year': { id: 52796282634424, price: 150 },
          '2years': { id: 52796282667192, price: 300 }
        }
      },
      exoWorks: {
        name: 'Exo Works Essentials',
        image: 'https://cdn.shopify.com/s/files/1/0778/3802/4888/files/Exo_Works_Extended.png?v=1771546459',
        enabled: false,
        selectedYear: '1year',
        variants: {
          '1year': { id: 52796225224888, price: 100 },
          '2years': { id: 52796225257656, price: 200 }
        }
      }
    };

    this.init();
  }

  async init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  async setup() {
    console.log('Setup started');

    let productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) {
      const productFormElement = document.querySelector('product-form');
      if (productFormElement) {
        productForm = productFormElement.querySelector('form');
      }
    }

    if (!productForm) {
      console.log('❌ Not on a product page - exiting');
      return;
    }

    const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    let devicePrice = 0;
    let softwarePrice = 0;

    if (productHandle) {
      try {
        const res = await fetch(`/products/${productHandle}.js`);
        const data = await res.json();
        devicePrice = data.variants[0]?.price / 100 || 0;
      } catch (e) {
        console.error('Error fetching product:', e);
      }
    }

    try {
      const res = await fetch(`/variants/${this.bundleItems.software.variantId}.js`);
      const data = await res.json();
      softwarePrice = data.price / 100 || 0;
    } catch (e) {
      console.warn('Could not fetch software price');
    }

    this.basePrice = devicePrice + softwarePrice;

    const priceElements = document.querySelectorAll('.price, .product__info-wrapper .price, .price--large');
    priceElements.forEach(el => el.style.display = 'none');

    const variantPicker = document.querySelector('.variant-picker, variant-selects, .product-form__input--dropdown');
    if (variantPicker) variantPicker.style.display = 'none';

    const fieldsets = document.querySelectorAll('fieldset, .product-form__input');
    fieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend');
      if (legend) fieldset.style.display = 'none';
    });

    // Bundle card
    const bundleCard = document.createElement('div');
    bundleCard.className = 'iris-learns-bundle-card selected';
    bundleCard.innerHTML = `
      <div class="iris-learns-checkmark"></div>
      <div class="iris-learns-header">
        <h3 class="iris-learns-plan-name">Learner Package</h3>
        <div class="iris-learns-price" id="iris-learns-total-price">${this.basePrice.toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
      </div>
      <div class="iris-learns-details">
        <div class="iris-learns-detail-item" id="iris-learns-warranty-text">1-year Device Protection</div>
        <div class="iris-learns-detail-item">AI software </div>
        <div class="iris-learns-detail-item" id="iris-learns-exoworks-text">1-year Exo Works Essential</div>
        <div class="iris-learns-detail-subtitle">Required to use Exo Iris.</div>
      </div>
    `;

    const buyButtons = productForm.closest('.product__info-wrapper, .product__info-container')
                        ?.querySelector('.product-form__buttons')?.parentNode 
                       || productForm.parentNode;
    
    buyButtons.parentNode.insertBefore(bundleCard, buyButtons);

    // Add-ons section
    const addonsSection = document.createElement('div');
    addonsSection.className = 'iris-learns-addons';
    addonsSection.innerHTML = `
      <h4 class="iris-learns-addons-title">Extend Your Access</h4>
      <p>Continue your warranty coverage and software beyond your first year.</p>
      ${this.createAddonHTML('warranty')}
      ${this.createAddonHTML('exoWorks')}
    `;
    bundleCard.after(addonsSection);

    // Program Name/Training Program input
    const programInput = document.createElement('div');
    programInput.className = 'iris-learns-program-input';
    programInput.innerHTML = `
      <label for="iris-learns-program">Training Program<span style="color: #dc2626;">*</span></label>
      <input 
        type="text" 
        id="iris-learns-program" 
        placeholder="e.g. Emergency Medicine Residency"
        required
      >
      <div class="iris-learns-program-error">Please enter your program name</div>
    `;
    addonsSection.after(programInput);

    // Set up add-on event listeners
    this.setupAddonListeners();

    // Intercept add to cart
    this.interceptAddToCart(productForm);

    console.log('=== Setup Complete ===');
  }

  createAddonHTML(addonKey) {
    const addon = this.addons[addonKey];
    const price1yr = addon.variants['1year'].price;

    return `
      <div class="iris-learns-addon" data-addon="${addonKey}">
        <div class="iris-learns-addon-layout">
          <img src="${addon.image}" alt="${addon.name}" class="iris-learns-addon-img">
          <div class="iris-learns-addon-content">
            <div class="iris-learns-addon-header">
              <div class="iris-learns-addon-info">
                <span class="iris-learns-addon-name">${addon.name}</span>
                <span class="iris-learns-addon-price" data-addon-price="${addonKey}">+$${price1yr}</span>
              </div>
              <label class="iris-learns-toggle">
                <input type="checkbox" data-addon-toggle="${addonKey}">
                <span class="iris-learns-toggle-slider"></span>
              </label>
            </div>
            <div class="iris-learns-addon-years" data-addon-years="${addonKey}">
              <button class="iris-learns-year-btn selected" data-addon="${addonKey}" data-year="1year">1 Year</button>
              <button class="iris-learns-year-btn" data-addon="${addonKey}" data-year="2years">2 Years</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  setupAddonListeners() {
    // Toggle switches
    document.querySelectorAll('[data-addon-toggle]').forEach(toggle => {
      toggle.addEventListener('change', (e) => {
        const addonKey = e.target.dataset.addonToggle;
        this.addons[addonKey].enabled = e.target.checked;
        
        const addonEl = e.target.closest('.iris-learns-addon');
        if (e.target.checked) {
          addonEl.classList.add('active');
        } else {
          addonEl.classList.remove('active');
        }
        
        this.updateBundleDisplay();
      });
    });

    // Year tabs
    document.querySelectorAll('.iris-learns-year-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const addonKey = e.target.dataset.addon;
        const year = e.target.dataset.year;
        
        this.addons[addonKey].selectedYear = year;

        // Update active tab
        const parent = e.target.closest('.iris-learns-addon-years');
        parent.querySelectorAll('.iris-learns-year-btn').forEach(b => b.classList.remove('selected'));
        e.target.classList.add('selected');

        // Update price display
        const price = this.addons[addonKey].variants[year].price;
        const priceEl = document.querySelector(`[data-addon-price="${addonKey}"]`);
        if (priceEl) priceEl.textContent = `+$${price}`;

        this.updateBundleDisplay();
      });
    });
  }

  // updateBundleDisplay() {
  //   let total = this.basePrice;

  //   Object.values(this.addons).forEach(addon => {
  //     if (addon.enabled) {
  //       total += addon.variants[addon.selectedYear].price;
  //     }
  //   });

  //   const priceEl = document.getElementById('iris-learns-total-price');
  //   if (priceEl) {
  //     priceEl.textContent = total.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     });
  //   }
  // }
  updateBundleDisplay() {
    // Update total price
    let total = this.basePrice;

    Object.values(this.addons).forEach(addon => {
      if (addon.enabled) {
        total += addon.variants[addon.selectedYear].price;
      }
    });

    const priceEl = document.getElementById('iris-learns-total-price');
    if (priceEl) {
      priceEl.textContent = total.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    // Update warranty text (base 1 year + addon years)
    const warrantyEl = document.getElementById('iris-learns-warranty-text');
    if (warrantyEl) {
      let warrantyYears = 1; // base
      if (this.addons.warranty.enabled) {
        warrantyYears += this.addons.warranty.selectedYear === '1year' ? 1 : 2;
      }
      warrantyEl.textContent = `${warrantyYears}-year Device Protection`;
    }

    // Update Exo Works text (base 1 year + addon years)
    const exoWorksEl = document.getElementById('iris-learns-exoworks-text');
    if (exoWorksEl) {
      let exoWorksYears = 1; // base
      if (this.addons.exoWorks.enabled) {
        exoWorksYears += this.addons.exoWorks.selectedYear === '1year' ? 1 : 2;
      }
      exoWorksEl.textContent = `${exoWorksYears}-year Exo Works Essential`;
    }
  }

  interceptAddToCart(form) {
    let addToCartBtn = form.querySelector('[name="add"]') ||
                       form.querySelector('button[type="submit"]') ||
                       form.querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit');

    if (!addToCartBtn) {
      console.error('❌ Could not find add to cart button');
      return;
    }

    const handler = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const programInput = document.getElementById('iris-learns-program');
      const programError = document.querySelector('.iris-learns-program-error');
      if (!programInput?.value?.trim()) {
        programInput.style.borderColor = '#dc2626';
        if (programError) programError.style.display = 'block';
        programInput.focus();
        return;
      }
      programInput.style.borderColor = '';
      if (programError) programError.style.display = 'none';

      const originalText = addToCartBtn.textContent;
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      try {
        await this.addToCart();
        addToCartBtn.textContent = 'Added!';
        setTimeout(() => {
          window.location.href = '/cart';
        }, 500);
      } catch (error) {
        console.error('❌ Error adding to cart:', error);
        alert('There was an error adding items to cart. Please try again.');
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }
    };

    form.onsubmit = handler;
    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (form.onsubmit) form.onsubmit(e);
    }, true);
  }

  async addToCart() {
    const rawInput = document.getElementById('iris-learns-program')?.value?.trim();
    const programName = rawInput
      .replace(/<[^>]*>/g, '')
      .replace(/[<>"'&]/g, '')
      .substring(0, 200);

    const items = [
      { id: this.bundleItems.device.variantId, quantity: 1, properties: { 'Program Name': programName } },
      { id: this.bundleItems.software.variantId, quantity: 1, properties: { 'Program Name': programName } }
    ];

    // Add enabled add-ons
    Object.values(this.addons).forEach(addon => {
      if (addon.enabled) {
        const variant = addon.variants[addon.selectedYear];
        items.push({
          id: variant.id,
          quantity: 1,
          properties: { 'Program Name': programName }
        });
        console.log(`✓ Adding add-on: ${addon.name} (${addon.selectedYear}) - $${variant.price}`);
      }
    });

    console.log('Cart request payload:', items);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ Cart API error:', errorData);
      throw new Error('Failed to add items to cart');
    }

    const result = await response.json();
    console.log('✓ Cart API success:', result);
    return result;
  }
}

console.log('Iris Learns Bundle script loaded');
new IrisLearnsBundle();